import { gql } from "@apollo/client";

const SUBMIT_PARTNER_FORM = gql`
mutation submitPartnerApplyForm($fullName: String!, $email: String!, $companyName: String!, $message: String!, $country: String!) {
  submitPartnerApplyForm(
    input: {email: $email, fullName: $fullName, companyName: $companyName, message: $message, country: $country}
  ) {
    fullName
    email
    companyName
    successMessage
    country
    errors
  }
}
`;

export default SUBMIT_PARTNER_FORM;
